import React, { useEffect, useState, useMemo } from 'react';
import QuadralAutocomplete from "@quadral/quadral-component-common/dist/components/autocomplete"
import QuadralContainer from "@quadral/quadral-component-common/dist/components/container"
import QuadralTimeline from "@quadral/quadral-component-common/dist/components/timeline";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPhone,
    faEnvelope,
    faCheck,
    faClipboard,
    faFileLines
} from "@fortawesome/free-solid-svg-icons";

export default function Activities({activityRecords, formatDate, assistanceType, setAssistanceType, setActivityOrder}) {

    const typeOptions = [
        {   label: 'Toutes',    value: '', },
		{   label: 'Appels',    value: 'Call', },
        {   label: 'Tâches',    value: 'Task'},
		{   label: 'Emails',    value: 'Email', },
		{   label: 'Journaux',    value: 'logs', }
    ];

    const motiveOptions = useMemo(() => [
        {   label: "-- Sélectionner un motif --",    value: "selectmotive", },
		{   label: "Global - Compréhension de l'enquête ou d'une relance",    value: "Global_Comprehension_de_l_enquete_ou_d_une_relance", },
		{   label: "Global - Le client ne dispose pas d'une pièce que nous lui avons demandé",    value: "Global_Le_client_ne_dispose_pas_d_une_piece_que_nous_lui_avons_demande", },
        {   label: "Global - Souhait de confirmer bonne réception du dossier",    value: "Global_Souhait_de_confirmer_bonne_reception_du_dossier", },
        {   label: "Papier - Usage - Accompagnement renseignement formulaire",    value: "Papier_Usage_Accompagnement_renseignement_formulaire", },
        {   label: "Télédéclaration - Usage - Accompagnement parcours en ligne (accès/saisie/validation)",    value: "Teledeclaration_Usage_Accompagnement_parcours_en_ligne", },
        {   label: "Télédéclaration - Usage - Souhait de réponse au format papier",      value: "Teledeclaration_Usage_Souhait_de_reponse_au_format_papier"     },
        {   label: "Télédéclaration - Usage - Téléchargement des pièces",      value: "Teledeclaration_Usage_Telechargement_des_pieces"     },
        {   label: "Télédéclaration - Problème technique",      value: "Teledeclaration_Probleme_technique"     },
        {   label: "Divers - Autres motifs",      value: "Divers_Autres_motifs"     },
    ], []);

    const[timeline, setTimeline] = useState([]);
    const[documentLink]=useState([]);
    const[selectedPreview, setSelectedPreview] = useState(false);
    const[previewName]=useState('')

    function getTypeIcon(type) {
        switch (type) {
            case "Call":
                return faPhone;
            case "Email":
                return faEnvelope;
            case "Task":
                return faClipboard;
            case "logs":
                return faFileLines;
            default:
                return faCheck;
        }
    };

    function getTypeColor(type) {
        switch (type) {
            case "Call":
                return 'success';
            case "Email":
                return 'info';
            case "Task":
                return 'info';
            case "logs":
                return 'warning';
            default:
                return 'secondary';
        }
    };

    // function isLink(string){
    //     try {
    //         new URL(string);
    //         return true;
    //     } catch (error) {
    //         return false;
    //     }
    // }

    // function preview(type, title, page) {
    //     setPreviewName(`${type} - ${title}`);
    //     setSelectedPreview(true);
    //     setDocumentLink(page);
    // }

    useEffect(() => {
        const newTimeline = activityRecords?.activities?.map((element) => ({
            title: element.subject
                ? (motiveOptions.find(opt => opt.value === element.subject)?.label || element.subject)
                : "Non renseigné",
            content: element.description,
            time: element.creationDate ? formatDate(element.creationDate.split("T")[0]) : "inconnu",
            icon: <FontAwesomeIcon icon={getTypeIcon(element.type)} />,
            iconColor: getTypeColor(element.type),
        }))

        setTimeline(newTimeline);
    }, [activityRecords, motiveOptions, formatDate]);

    return (
        <>
        <QuadralContainer orientation='row' style={{transition: 'all 0.3s'}}>
            <QuadralContainer orientation='column'
                style={{
                    maxWidth: "100%",
                    minWidth: '55%',
                    transition: "max-width 0.5s ease-in-out"
                }}>
                <div style={{display: 'flex', gap: "1rem", alignItems: 'center', marginBottom: '1rem'}}>
                    <span>{activityRecords?.totalCount} activité{activityRecords?.totalCount > 1 ? 's' : ''} trouvée{activityRecords?.totalCount > 1 ? 's' : ''}</span>
                    <QuadralAutocomplete
                        value={typeOptions.find(o => o.value === assistanceType) ?? null}
                        onChange={(event, newValue) => {
                            setAssistanceType(newValue?.value ?? "")
                        }}
                        label="Type d'activité"
                        options={typeOptions}
                        getOptionLabel = {(option) => option?.label ?? ""}
                        sx={{minWidth: '200px'}}
                    />
                </div>
                <QuadralTimeline timeline={timeline}/>
            </QuadralContainer>
                <QuadralContainer orientation='column'
                    className="supporting-doc-list" style={{
                    display: selectedPreview ? "flex" : "none",
                    flexDirection: "column",
                    marginBottom: "1rem",
                    transition: "max-width 0.5s ease-in-out",
                    minHeight: selectedPreview ? "740px" : '0px',
                    minWidth: "20rem"
                    }}>
                    <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: '10px' }}>
                        <div className='panel-title detail-title c-pb-0'
                            style={{ margin: '7px 0 7px 0' }}>{previewName}</div>
                    </div>
                    <div className="preview-close" style={{ backgroundColor: 'grey' }}>
                        <button className="preview-close-btn" style={{ backgroundColor: 'grey', color: 'white', border: 'none' }} onClick={() => setSelectedPreview(null)} title="Fermer la prévisualisation">
                            <i className="fa-regular fa-xmark fa-f2" style={{ backgroundColor: 'grey' }} />
                        </button>
                    </div>
                    {documentLink && documentLink?.length > 0 ? (
                        <object aria-label='Prévisualisation du document' type='application/pdf' width="100%" className="h-100 w-100"
                            data={`${documentLink}#zoom=FitH`} />
                    ) : (
                        <>
                        <div>
                            Erreur lors de la récupération du courrier
                        </div>
                        </>
                    )}
                </QuadralContainer>
            </QuadralContainer>
        </>
    );
}